<template>
  <Button
    class="google-signin"
    @click="login"
    :loading="loading"
    :disabled="!inited"
  >
    <img
      class="google-signin__logo"
      src="@/assets/google.svg"
      alt="Google sign in"
    >
    <div>Continue with Google</div>
  </Button>
</template>

<script setup>
import { buriedPointUtil, gaAnalytics } from '@/utils/utils'
import { useStore } from 'vuex'
import { useLogin } from '@/components/Login'
import { useGoogle } from '@/hooks/useGoogle'
import { usePlugin } from '@/hooks/usePlugin'
import { Button } from '@/components/Button'
import { deviceType } from '@/utils/constants'

const store = useStore()

const passiveLogin = computed(() => store.state.passiveLogin)
const { inited, requestAccessToken } = useGoogle()
const { login: googleLogin } = useLogin()
const { $toast } = usePlugin()

const loading = ref(false)

const login = async () => {
  loading.value = true
  try {
    if (deviceType === 'MOBILE') {
      buriedPointUtil({ eventId: 'MPLG203' })
      gaAnalytics('mp_login_click', 'mp_login_click', {
        passiveLogin: passiveLogin.value,
        loginType: 'continue_with_google'
      })
    } else {
      buriedPointUtil({ eventId: 'PLG203' })
      gaAnalytics('p_login_click', 'p_login_click', {
        passiveLogin: passiveLogin.value,
        loginType: 'continue_with_google'
      })
    }
    const { access_token: accessToken } = await requestAccessToken()
    await googleLogin({
      loginType: 'google',
      accessToken
    })
  } catch (e) {
    $toast(e.message, { type: 'error' })
  } finally {
    loading.value = false
  }
}
</script>

<style lang="less" scoped>
.google-signin {
  &__logo {
    margin-right: 4px;
    width: 20px;
    height: 20px;
  }
}
</style>
